import React from "react";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SportsCricketOutlinedIcon from "@mui/icons-material/SportsCricketOutlined";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateActive } from "../redux/activeSlice";
import { Gift, LoaderPinwheelIcon } from "lucide-react";
import LuckySpinIcon from "../assets/icon-roulette.be0624e.png";
import BonusIcon from "../assets/bonus.png";
import HomeIcon from "../assets/home.png";

const ITEMS = [
  {
    name: "Lobby",
    path: "/",
    icon: HomeIcon,
    iconImage: true,
    active: true,
  },
  {
    name: "Cricket",
    path: "/cricket",
    icon: <SportsCricketOutlinedIcon />,
    iconImage: false,
    active: true,
  },
  {
    name: "Bonus",
    path: "/bonus",
    icon: BonusIcon,
    iconImage: true,
    active: true,
  },
  {
    name: "Lucky Spin",
    path: "/lucky-spin",
    icon: LuckySpinIcon,
    iconImage: true,
    active: true,
  },
];

export default function Sidebar() {
  const activeRoute = useSelector((state) => state.active.activeRoute);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClickItem = (path) => {
    dispatch(updateActive({ activeRoute: path }));
    navigate(path);
  };

  return (
    <div className="md:flex flex-row md:flex-col w-full md:w-20 bg-[#0B1622] md:border-r border-[#66a1ff33] h-full">
      <div className="flex md:flex-col items-center justify-between md:py-4 ms-3 md:m-0">
        {ITEMS.map((item) => (
          <button
            key={item.name}
            disabled={!item.active}
            className={`p-3 rounded-lg flex flex-col font-medium items-center hover:bg-gray-800 ${
              activeRoute === item.path ? "text-white" : "text-gray-600"
            }`}
            onClick={() => onClickItem(item.path)}
          >
            {!item.iconImage ? (
              <div className="text-[#c2c2c2]">{item.icon}</div>
            ) : (
              <img
                className={`${
                  activeRoute === item.path ? "opacity-100" : "opacity-70"
                }`}
                src={item.icon}
                width={24}
              />
            )}
            <div className="text-xs text-[#c2c2c2] mt-1">{item.name}</div>
          </button>
        ))}
      </div>
      <button
        disabled={false}
        className={`p-3 rounded-lg hidden md:block hover:bg-gray-800 ${
          activeRoute === "/jetx" ? "text-white" : "text-gray-600"
        }`}
        onClick={() => onClickItem("/jetx")}
      >
        {/* <div>{item.icon}</div> */}
        <div className="text-xs mt-1 font-bold">JETX</div>
      </button>
    </div>
  );
}
